<template>
  <layout title="Courses">
    <div class="row">
      <div class="col-10">
        <h2 class="page-heading">
          <inertia-link
            class="previous-path-header"
            :href="route('courses.index')"
          >
            Courses
          </inertia-link>
          / {{ form.name }}
        </h2>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card shadow-sm p-3 mb-5 bg-white rounded mt-2">
          <div class="card-body col-md-12">
            <FlashMessage :flash="flash" />
            <ul class="nav nav-tabs" id="formTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="data-tab"
                  data-toggle="tab"
                  href="#data"
                  role="tab"
                  aria-controls="data"
                  aria-selected="true"
                >
                  Data
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="content-tab"
                  data-toggle="tab"
                  href="#content"
                  role="tab"
                  aria-controls="content"
                  aria-selected="false"
                >
                  Content
                </a>
              </li>
            </ul>
            <div class="tab-content">
              <div
                class="tab-pane fade show active"
                id="data"
                role="tabpanel"
                aria-labelledby="data-tab"
              >
                <div class="row">
                  <div class="col-md-8">
                    <form class="mt-4" @submit.prevent="update">
                      <div class="form-group row">
                        <label for="name" class="col-sm-2 col-form-label">
                          Name
                        </label>
                        <div class="col-sm-10">
                          <input
                            type="text"
                            class="form-control"
                            id="name"
                            placeholder="Tenant name"
                            v-model="form.name"
                          />
                          <div
                            v-if="errors && errors.name"
                            class="d-block invalid-feedback"
                          >
                            {{ errors.name }}
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="name" class="col-sm-2 col-form-label">
                          Description
                        </label>
                        <div class="col-sm-10">
                          <textarea
                            class="form-control"
                            id="description"
                            rows="5"
                            v-model="form.description"
                          />
                          <div
                            v-if="errors && errors.description"
                            class="d-block invalid-feedback"
                          >
                            {{ errors.description }}
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-sm-12">
                          <button
                            type="submit"
                            class="btn btn-primary float-right"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="content"
                role="tabpanel"
                aria-labelledby="content-tab"
              >
                <div class="row">
                  <div class="col-md-8">
                    <FileUploader @submitted="handleFileUploadSubmit" />
                  </div>
                </div>

                <hr />
                <h4>
                  Uploaded content (
                  <code>{{ formatBytes(content.size) }}</code>
                  )
                </h4>

                <div class="mt-4 row">
                  <div
                    v-for="content_item in content.files.data"
                    :key="content_item.id"
                    class="col-md-2 p-1"
                  >
                    <div class="card h-100">
                      <span class="size-label">
                        {{ formatBytes(content_item.meta_data.size, 0) }}
                      </span>
                      <img
                        class="card-img-top"
                        v-if="content_item.file_type == 'image/jpeg'"
                        :src="
                          getMediaItemLink(
                            content_item.file_path,
                            content_item.storage_disk
                          )
                        "
                        alt="Card image cap"
                      />
                      <img
                        class="card-img-top"
                        v-else
                        src="/images/files.png"
                        alt="Card image cap"
                      />

                      <div
                        class="file-box card-body"
                        :title="content_item.name"
                      >
                        {{ content_item.name }}
                      </div>
                    </div>
                  </div>

                  <!-- <div v-for="content_item in content" :key="content_item.id" class="card m-2 col-md-3">
                    <span class="size-label">{{ Math.ceil((content_item.meta_data.size / 1000)) }}kb</span>
                    <div class="embed-responsive embed-responsive-16by9">
                    <img v-if="content_item.type == 'image/jpeg'" class="card-img-top" :src="'http://jlea.test:9600/minio-s3/' + content_item.file_path" alt="Card image cap" />
                    </div>
                    <div class="card-body">
                      <p class="card-text">
                        {{ content_item.name }}
                      </p>
                    </div>
                  </div> -->
                </div>

                <div class="row mt-3">
                  <div class="col-md-12">
                    <nav aria-label="Page navigation example">
                      <ul class="pagination justify-content-end">
                        <li
                          class="page-item"
                          v-for="link in content.files.links"
                          :class="{ active: link.active }"
                          :key="link.label"
                        >
                          <inertia-link
                            v-if="link.url"
                            class="page-link"
                            :href="link.url + '#content'"
                            :only="['content']"
                            preserve-scroll
                          >
                            <span v-html="link.label"></span>
                          </inertia-link>
                          <span class="page-link" v-else>
                            <span v-html="link.label"></span>
                          </span>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";
import FileUploader from "../../Components/FileUploader";
import { onMounted } from "vue";

export default {
  setup() {
    onMounted(() => {
      const hash = location.hash;
      const accepted_hashes = ["#data", "#content"];

      if (hash && accepted_hashes.includes(hash)) {
        $(`#formTab a[href="${hash}"]`).tab("show");
      }
    });
  },
  layout: AppLayout,
  props: {
    errors: Object,
    course: Object,
    content: {
      files: Object,
      size: Number,
    },
    flash: Object,
  },
  components: {
    FileUploader: FileUploader,
  },
  data() {
    return {
      form: {
        name: this.course.name,
        description: this.course.description,
      },
    };
  },
  methods: {
    update() {
      this.$inertia.patch(route("courses.update", this.course.id), this.form);
    },
    handleFileUploadSubmit(files) {
      let data = new FormData();
      data.append("course_id", this.course.id);

      for (let i = 0; i < files.length; i++) {
        data.append("content_files[]", files[i]);
      }

      this.$inertia.post(route("courses.add_content"), data);
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
  },
};
</script>
